import React, {useCallback, useMemo} from "react";
import Anchor from "../../../HTMLEntities/Anchor";
import {GNBDataLevelThree, RightSubMenuData} from "../../types";
import {RightSubMenuList} from "../HeaderStyled";

interface Props {
    rightSubMenuData: RightSubMenuData;
    activeLeftTabIndex: string;
    navMenuClick: () => void;
}

const RightMenu: React.FC<Props> = ({
    rightSubMenuData,
    activeLeftTabIndex,
    navMenuClick,
}: Props) => {
    const renderRightMenuSubSections = useCallback(
        (subSection: GNBDataLevelThree[], title: string) => {
            return (
                <RightSubMenuList className={"sub-sub-menu2"}>
                    {title && (
                        <li>
                            <label>{title}</label>
                        </li>
                    )}
                    {subSection.map((sectionData, index) => {
                        return (
                            <li key={`rmss_${index}`}>
                                <Anchor
                                    linkHref={sectionData.url ? sectionData.url : ""}
                                    linkLabel={sectionData.title}
                                    className="pnl_a gaTrack"
                                    eventCategory={"GNB"}
                                    disabledExternalValidation={true}
                                    // eventAction={"ABROAD_GNB," + navGroupData.title}
                                    target="_self"
                                    onPathChange={() => navMenuClick()}
                                    displayStyle={{
                                        laptop: {
                                            maxWidth: "100%",
                                            width: "100%",
                                        },
                                        mobile: {
                                            maxWidth: "100%",
                                            width: "100%",
                                        },
                                    }}
                                />
                            </li>
                        );
                    })}
                </RightSubMenuList>
            );
        },
        [navMenuClick],
    );

    return useMemo(() => {
        if (rightSubMenuData) {
            const activeSubSection = rightSubMenuData[activeLeftTabIndex];
            return (
                <ul>
                    {activeSubSection &&
                        activeSubSection.map((mainSectionArr, indexArr) => {
                            return (
                                <li key={`msr_${indexArr}`}>
                                    {mainSectionArr.child &&
                                        renderRightMenuSubSections(
                                            mainSectionArr.child,
                                            mainSectionArr.title,
                                        )}
                                </li>
                            );
                        })}
                </ul>
            );
        }
        return null;
    }, [activeLeftTabIndex, rightSubMenuData, renderRightMenuSubSections]);
};

export default RightMenu;
